import ArrowIcon from '@/fo/icons/base/landing/arrow-down.svg';
import { utilScrollToElement } from '@/fo/util/scroll-to-element';

import { styles } from './ArrowDown.styles';

export interface ArrowDownProps {
  className?: string;
  targetId?: string;
}

export function ArrowDown({ className, targetId }: ArrowDownProps) {
  const slots = styles();

  const handleClick = () => {
    const el =
      typeof document !== 'undefined'
        ? (document.getElementById(targetId ?? '') as HTMLElement | null)
        : null;
    utilScrollToElement(el);
  };

  return (
    <div
      className={slots.base({ className })}
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      <ArrowIcon className={slots.arrow()} />
      <ArrowIcon className={slots.arrowDelayed()} />
    </div>
  );
}
